module.exports = __webpack_public_path__ + "static/img/defaultTheme.adca020.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/defaultTheme.png
// module id = jvHO
// module chunks = 10